module.exports = __webpack_public_path__ + "img/1@3x.5d50b759.png";